export enum MusicNoteName {
  A = "A",
  Asharp = "A#",
  Aflat = "Ab",
  B = "B",
  Bsharp = "B#",
  Bflat = "Bb",
  C = "C",
  Csharp = "C#",
  Cflat = "Cb",
  D = "D",
  Dsharp = "D#",
  Dflat = "Db",
  E = "E",
  Esharp = "E#",
  Eflat = "Eb",
  F = "F",
  Fsharp = "F#",
  Fflat = "Fb",
  G = "G",
  Gsharp = "G#",
  Gflat = "Gb",
}

/** may need more specific name, see how it grows */
export interface MusicNote {
  name?: MusicNoteName;
  sharpName?: MusicNoteName;
  flatName?: MusicNoteName;
}

export function isSameMusicNote(a?: MusicNote, b?: MusicNote) {
  return (
    a &&
    b &&
    ((a.name && b.name && a.name === b.name) ||
      (a.flatName && b.flatName && a.flatName === b.flatName))
  );
}

export function toStringMusicNote(a?: MusicNote) {
  return [a?.flatName, a?.name, a?.sharpName].filter((x) => !!x).join("/");
}
